import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import HeaderBar from './HeaderBar'
import StartCard from './StartCard'
import StoryCard from './StoryCard'
import { selectStories } from './features/storiesReducer'
import { selectExhibit } from './features/exhibitReducer'

function StoryFrame() {
  const dispatch = useDispatch()

  const storyData = useSelector(selectStories)
  const exhibit = useSelector(selectExhibit)

  const stories = storyData.map(s => StoryCard(s, exhibit.mainColor, dispatch, exhibit.mapZoom))

  const storyFrame = {
    position: 'absolute',
    left: 0,
    top: 0,
    height: '100vh',
    width: '425px',
    overflow: 'scroll',
    boxShadow: '10px 0px 25px 0px rgba(0,0,0,0.5)',
    zIndex: '555',
  }

  return (
    <div style={storyFrame}>
      <HeaderBar />
      <StartCard />
       { stories }
    </div>
  )
}

export default StoryFrame
